import { useEffect, useState } from "react"
import { useSearchParams, Link } from "react-router-dom"
import { Loader2 } from "lucide-react"
import { Button } from "@/components/ui/button"
import { AuthLayout } from "@/components/auth/AuthLayout"
import { FormAlert } from "@/components/auth/FormAlert"
import { authService } from "@/services/authService"
import { useAuthStore } from "@/store/authStore"

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get("token") ?? ""
  const { setAuth, isAuthenticated } = useAuthStore()

  const [status, setStatus] = useState<"loading" | "success" | "error">(token ? "loading" : "error")
  const [errorMsg, setErrorMsg] = useState(token ? "" : "O link está incompleto. Abra de novo o link enviado para o seu e-mail.")

  useEffect(() => {
    if (!token) return

    authService.verifyEmail(token)
      .then(() => {
        // Atualiza o usuário no store se houver sessão; sem sessão o banco já está marcado como verificado
        authService.me()
          .then((user) => setAuth(user))
          .catch(() => { /* sem sessão: nada a atualizar */ })
        setStatus("success")
      })
      .catch((err: unknown) => {
        const axiosErr = err as { response?: { data?: { error?: string } } }
        setErrorMsg(axiosErr.response?.data?.error || "Link inválido ou expirado.")
        setStatus("error")
      })
  }, [token, setAuth])

  if (status === "loading") {
    return (
      <AuthLayout pageTitle="Confirmando e-mail" title="Confirmando seu e-mail">
        <p className="flex items-center gap-2 text-muted-foreground" role="status">
          <Loader2 className="h-4 w-4 animate-spin" /> Só um instante...
        </p>
      </AuthLayout>
    )
  }

  if (status === "success") {
    return (
      <AuthLayout pageTitle="E-mail confirmado" title="E-mail confirmado"
        description="Sua conta está ativa e todos os recursos do seu plano estão liberados.">
        <Button asChild size="lg" className="w-full">
          <Link to={isAuthenticated ? "/dashboard" : "/login"}>{isAuthenticated ? "Ir para o painel" : "Entrar"}</Link>
        </Button>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout pageTitle="Confirmação de e-mail" title="Não foi possível confirmar">
      <div className="space-y-5">
        <FormAlert>{errorMsg}</FormAlert>
        <p className="text-[14px] text-muted-foreground">
          Entre na sua conta e use "Reenviar e-mail" no aviso do topo para receber um link novo.
        </p>
        <Button asChild size="lg" variant="outline" className="w-full">
          <Link to="/login">Voltar ao login</Link>
        </Button>
      </div>
    </AuthLayout>
  )
}
